import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { useLocation } from 'react-router-dom';
import { IAdminxStore } from '../../stores';

export function useBidderAdvertiserGet(props: ICrudGetProps) {
	const { id } = props;
	const { bidderAdvertiserStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			bidderAdvertiserStore.getCrud().getBidderAdvertiser(id);
		}
		// TODO - think maybe when unmount reset to crud model
	}, [location]);

	if (!id) {
		return null;
	}

	return {
		loaded: !!bidderAdvertiserStore.getCrud().getData().getId(),
		error: bidderAdvertiserStore.getCrud().getHttpError(),
		isLoading: bidderAdvertiserStore.getCrud().getIsLoading(),
	};
}
